import { gql } from "@apollo/client";

const ORDER_SUMMARY_FIELDS = `
  id
  bookingId
  status
  bookingDate
  price
  amountPaid
  amountDue
  paymentType
  verificationStatus
  customerName
  customerContact
  employeeName
`;

const LINK_FIELDS = `
  id
  purpose
  razorpayLinkId
  shortUrl
  amount
  description
  category
  bookingId
  employeeId
  employeeName
  orderIds
  customerName
  customerContact
  status
  razorpayPaymentId
  paidAt
  processingNote
  expiresAt
  createdAt
`;

export const GET_UNLINKED_RAZORPAY_PAYMENTS = gql`
  query GetUnlinkedRazorpayPayments($data: UnlinkedRazorpayPaymentsFilter) {
    getUnlinkedRazorpayPayments(data: $data) {
      status
      message
      total
      unlinkedCount
      unlinkedAmount
      payments {
        id
        razorpayPaymentId
        paymentLinkId
        amount
        method
        vpa
        contact
        email
        description
        linkCreatedBy
        paidAt
        reason
        status
        suggestedKind
        suggestedOrder { ${ORDER_SUMMARY_FIELDS} }
        suggestedEmployeeId
        suggestedEmployeeName
        linkedOrder { ${ORDER_SUMMARY_FIELDS} }
        linkedEmployeeName
        resolvedAt
        resolutionNote
      }
    }
  }
`;

export const GET_ADMIN_PAYMENT_LINKS = gql`
  query GetAdminPaymentLinks($data: AdminPaymentLinksFilter) {
    getAdminPaymentLinks(data: $data) {
      status
      message
      total
      links { ${LINK_FIELDS} }
    }
  }
`;

export const GET_PAYMENT_LINK_BOOKING_INFO = gql`
  query GetPaymentLinkBookingInfo($bookingId: String!) {
    getPaymentLinkBookingInfo(bookingId: $bookingId) {
      status
      message
      booking { ${ORDER_SUMMARY_FIELDS} }
    }
  }
`;

export const GET_EMPLOYEE_UNSETTLED_ORDERS = gql`
  query GetEmployeeUnsettledOrders($employeeId: ID!) {
    getEmployeeUnsettledOrders(employeeId: $employeeId) {
      status
      message
      totalAmount
      orders {
        id
        bookingId
        bookingDate
        price
        paymentType
        settlementAmount
      }
    }
  }
`;

export const GET_EMPLOYEES = gql`
  query getEmployeeListForPayments($data: EmployeeFilterInput) {
    getEmployeelist(data: $data) {
      employee {
        id
        fullName
        contactNumber
      }
    }
  }
`;

export const GENERATE_ADMIN_PAYMENT_LINK = gql`
  mutation GenerateAdminPaymentLink($data: GenerateAdminPaymentLinkInput!) {
    generateAdminPaymentLink(data: $data) {
      status
      message
      link { ${LINK_FIELDS} }
    }
  }
`;

export const CANCEL_ADMIN_PAYMENT_LINK = gql`
  mutation CancelAdminPaymentLink($id: ID!) {
    cancelAdminPaymentLink(id: $id) {
      status
      message
    }
  }
`;

export const RESOLVE_UNLINKED_RAZORPAY_PAYMENT = gql`
  mutation ResolveUnlinkedRazorpayPayment(
    $data: ResolveUnlinkedRazorpayPaymentInput!
  ) {
    resolveUnlinkedRazorpayPayment(data: $data) {
      status
      message
    }
  }
`;
